import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "windSpeed",
  "use": "windSpeed-usage",
  "viewBox": "0 0 20 18.42",
  "content": "<symbol viewBox=\"0 0 20 18.42\" id=\"windSpeed\"><title>windSpeed</title><path d=\"M13.2,13H.58a.58.58,0,0,0,0,1.16H13.2a1.93,1.93,0,1,1-1.76,2.71.58.58,0,0,0-1.06.47A3.09,3.09,0,1,0,13.2,13ZM16.36,3.3a3.64,3.64,0,0,0-3.53,2.76.58.58,0,1,0,1.13.28,2.48,2.48,0,1,1,2.41,3.08H.58a.58.58,0,0,0,0,1.16H16.36a3.64,3.64,0,0,0,0-7.29ZM.58,7h7.7A3.09,3.09,0,1,0,5.46,2.62a.58.58,0,1,0,1.06.47A1.93,1.93,0,1,1,8.28,5.8H.58A.58.58,0,1,0,.58,7Zm0,0\" transform=\"translate(0 -0.79)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/windSpeed.svg
// module id = ttwx
// module chunks = 264